var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_privacy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5039 17.8711C17.0432 17.8711 17.4805 17.4339 17.4805 16.8945C17.4805 16.3552 17.0432 15.918 16.5039 15.918C15.9646 15.918 15.5273 16.3552 15.5273 16.8945C15.5273 17.4339 15.9646 17.8711 16.5039 17.8711Z",
    fill: "#1E3799"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.621 23.0478H3.90623C2.82929 23.0478 1.95312 22.1716 1.95312 21.0947V13.0869C1.95312 12.0099 2.82929 11.1338 3.90623 11.1338H17.9687C19.0456 11.1338 19.9218 12.0099 19.9218 13.0869V15.04C19.9218 15.5794 20.359 16.0166 20.8984 16.0166C21.4377 16.0166 21.8749 15.5794 21.8749 15.04V13.0869C21.8749 10.933 20.1226 9.18064 17.9687 9.18064H16.795V5.73661C16.795 2.57397 14.1665 0.000976562 10.9357 0.000976562C7.7048 0.000976562 5.0763 2.57397 5.0763 5.73661V9.18064H3.90623C1.75234 9.18064 0 10.933 0 13.0869V21.0947C0 23.2486 1.75234 25.0009 3.90623 25.0009H11.621C12.1604 25.0009 12.5976 24.5637 12.5976 24.0243C12.5976 23.485 12.1604 23.0478 11.621 23.0478ZM7.02942 5.73661C7.02942 3.65092 8.78175 1.9541 10.9357 1.9541C13.0895 1.9541 14.8419 3.65092 14.8419 5.73661V9.18064H7.02942V5.73661Z",
    fill: "#1E3799"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.5919 15.9052C24.1533 15.5911 23.5432 15.6922 23.2294 16.1307L18.4159 22.8543C18.2845 23.0068 18.1197 23.0397 18.0314 23.0455C17.9409 23.0515 17.7666 23.0401 17.6131 22.8961L14.5024 19.8604C14.1163 19.4836 13.4981 19.4913 13.1214 19.8772C12.7447 20.2632 12.7522 20.8815 13.1383 21.2582L16.2545 24.2992C16.2574 24.3021 16.2603 24.3049 16.2633 24.3077C16.7304 24.7525 17.354 24.9999 17.9956 24.9999C18.0507 24.9999 18.106 24.9981 18.1613 24.9944C18.8602 24.9478 19.5128 24.6079 19.9516 24.0619C19.9629 24.0477 19.9739 24.0333 19.9845 24.0186L24.8175 17.2676C25.1314 16.8291 25.0304 16.2191 24.5919 15.9052Z",
    fill: "#1E3799"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.793 17.8711C13.3323 17.8711 13.7695 17.4339 13.7695 16.8945C13.7695 16.3552 13.3323 15.918 12.793 15.918C12.2536 15.918 11.8164 16.3552 11.8164 16.8945C11.8164 17.4339 12.2536 17.8711 12.793 17.8711Z",
    fill: "#1E3799"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.46875 17.8711C6.00808 17.8711 6.4453 17.4339 6.4453 16.8945C6.4453 16.3552 6.00808 15.918 5.46875 15.918C4.92941 15.918 4.49219 16.3552 4.49219 16.8945C4.49219 17.4339 4.92941 17.8711 5.46875 17.8711Z",
    fill: "#1E3799"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.13086 17.8711C9.67019 17.8711 10.1074 17.4339 10.1074 16.8945C10.1074 16.3552 9.67019 15.918 9.13086 15.918C8.59152 15.918 8.1543 16.3552 8.1543 16.8945C8.1543 17.4339 8.59152 17.8711 9.13086 17.8711Z",
    fill: "#1E3799"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPrivacy);
export default __webpack_public_path__ + "static/media/icn_privacy.fc0ef2fb4d5b6b965e1505e5c538f367.svg";
export { ForwardRef as ReactComponent };